import {LayoutAbbreviation, LayoutType} from "./constants";
import {UseFullSizeImages} from "../../../config";

let layouts = {};
Object.keys(LayoutType).forEach(layoutName => {
  layouts[layoutName] = {
    Background: {
      BackgroundBG: 100,
      Floor: 200,
      LeftWall: 300,
      ShowerWall: 400,
      RightWall: 550,
      CenterWall: 600,
    },
    ShowerWallAccent: 1000,
    Accessories: {
      WindowBody: 1000,
      WindowKits: 1100,
      LargeCornerCaddie: 2010,
      LargeCornerCaddie2: 2020,
      Fixture: 2100,
      CornerCaddie: 2410,
      CornerCaddie2: 2420,
      SoapDish: 2500,
      SoapDish2: 2510,
      SoapDish3: 2520,
      SmallCornerShelf: 2600,
      CornerShelf1: 2810,
      CornerShelf2: 2820,
      CornerShelf3: 2830,
      CornerShelf4: 2840,
      CornerShelf5: 2850,
      CornerShelf6: 2860,
      ShowerPod: 2900,
      LargeShelf: 2905,
      ShampooShelf: 2902,
      LargeCornerSeat: 3330,
      LargeCornerSeat2: 3340,
      GrabBar: 3500, // more that the fixture
      GrabBar2: 3510,
      GrabBar3: 3520,
      Seats: 3810,
      Seats2: 3820,
      HandleShowerValve: 3830,
      HandleShowerValve2: 3840,
      LShapedGrabBar: 3850,
      LShapedGrabBar2: 3860,
      SeatPad: 3870,
      SeatPad2: 3880,
      HandShowerKit: 3890,
      HandShowerKit2: 3900,
      ShowerRod: 4200,
      TowelBar: 4250,
    },
    Shower: {
      ShowerPan: 3200,
      ShowerPanCombo: 3300,
      ShowerArm: 3350,
      ShowerArm2: 3360,
      ShowerHead: 3370,
      ShowerHead2: 3380,
      ShowerFixture: 3410,
      ShowerFixture2: 3420,
      ShowerFixture3: 3430,
      ShowerDoorHandle: 3600,
      // Threshold
      TubCombo: {
        WallConfiguration: 3600,
        Liner: 3700,
        ReplacementTub: 3800,
        WalkInTub: 3910,
        JettedTub: 4000,
      },
      ShowerDoor: 4100,
      ShowerDoor2: 4110,
    },
    Walls: {
      LeftWall: 4800,
      CeilingPanels: 4050, // less than shower doors
      RightWall: 4900,
    },
    Toilet: 5000,
    PaperHolder: 5050,
    Vanity: {
      Cabinet: 6000,
      Handle: 6100,
      CounterTop: 6200,
      VanityBacksplash: 6300,
      Mirror: 6400,
      Faucet: 6500,
      Sink: 6600,
    },
    Globals: {
      ToiletPaper: 8000,
      ToiletPaperHolder: 8050,
      Towel: 8100,
      LightFixture: 8200,
      LampFixture: 8250,
      DecorWindow: 8300,
      DecorSeat: 8400,
    },
    Bathtub: {
      BathTubFixture: 9000,
      BathTubBody: 9100,
    }
  };
});

layouts["Layout4"].Vanity = {
  Cabinet: 10000,
  Handle: 10100,
  CounterTop: 10200,
  VanityBacksplash: 10300,
  Mirror: 10400,
  Faucet: 10500,
  Sink: 10600,
};
layouts["Layout4"].Globals.DecorWindow = 1200;
layouts["Layout4"].Toilet = 15000;
layouts["Layout4"].Globals.DecorSeat = 18000;
layouts["Layout4"].Globals.LightFixture = 19000;
layouts["Layout4"].Globals.LampFixture = 19100;
layouts["Layout4"].Globals.ToiletPaperHolder = 20000;
layouts["Layout4"].PaperHolder = 20000;


const getLayerDimensions = (zIndex, currentLayout) => {
  const fullImagesFactor = UseFullSizeImages ? 177.77 : 100;
  const sizeFactor = fullImagesFactor / 100;
  switch (zIndex) {
    // case layouts[currentLayout].Background.ShowerWall:
    //   return {
    //     polygonArray: [[sizeFactor*350,sizeFactor*50],[sizeFactor*950,sizeFactor*50],[sizeFactor*950,sizeFactor*930],[sizeFactor*350,sizeFactor*930]],
    //     width: sizeFactor*600,
    //     height: sizeFactor*900
    //   };
    case layouts[currentLayout].Shower.ShowerFixture:
    case layouts[currentLayout].Shower.ShowerFixture2:
    case layouts[currentLayout].Shower.ShowerFixture3:
    case layouts[currentLayout].Shower.ShowerDoorHandle:
    case layouts[currentLayout].Shower.ShowerArm:
    case layouts[currentLayout].Shower.ShowerArm2:
    case layouts[currentLayout].Shower.ShowerHead:
    case layouts[currentLayout].Shower.ShowerHead2:
    case layouts[currentLayout].ShowerWallAccent:
    case layouts[currentLayout].Accessories.Fixture:
    case layouts[currentLayout].Accessories.LargeCornerSeat:
    case layouts[currentLayout].Accessories.LargeCornerSeat2:
    case layouts[currentLayout].Accessories.CornerCaddie:
    case layouts[currentLayout].Accessories.CornerCaddie2:
    case layouts[currentLayout].Accessories.SoapDish:
    case layouts[currentLayout].Accessories.SoapDish2:
    case layouts[currentLayout].Accessories.SoapDish3:
    case layouts[currentLayout].Accessories.SmallCornerShelf:
    case layouts[currentLayout].Accessories.GrabBar:
    case layouts[currentLayout].Accessories.GrabBar2:
    case layouts[currentLayout].Accessories.GrabBar3:
    case layouts[currentLayout].Accessories.CornerShelf1:
    case layouts[currentLayout].Accessories.CornerShelf2:
    case layouts[currentLayout].Accessories.CornerShelf3:
    case layouts[currentLayout].Accessories.CornerShelf4:
    case layouts[currentLayout].Accessories.CornerShelf5:
    case layouts[currentLayout].Accessories.CornerShelf6:
    case layouts[currentLayout].Accessories.ShowerPod:
    case layouts[currentLayout].Accessories.LargeShelf:
    case layouts[currentLayout].Accessories.Seats:
    case layouts[currentLayout].Accessories.Seats2:
    case layouts[currentLayout].Accessories.SeatPad:
    case layouts[currentLayout].Accessories.SeatPad2:
    case layouts[currentLayout].Accessories.LShapedGrabBar:
    case layouts[currentLayout].Accessories.LShapedGrabBar2:
    case layouts[currentLayout].Accessories.HandleShowerValve:
    case layouts[currentLayout].Accessories.HandleShowerValve2:
    case layouts[currentLayout].Accessories.HandShowerKit:
    case layouts[currentLayout].Accessories.HandShowerKit2:
    case layouts[currentLayout].Accessories.ShowerRod:
    case layouts[currentLayout].Accessories.WindowBody:
    case layouts[currentLayout].Accessories.WindowKits: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*350,sizeFactor*130],[sizeFactor*950,sizeFactor*130],[sizeFactor*950,sizeFactor*930],[sizeFactor*350,sizeFactor*930]],
            width: sizeFactor*600,
            height: sizeFactor*800
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*560,0],[sizeFactor*1240,0],[sizeFactor*1240,sizeFactor*930],[sizeFactor*560,sizeFactor*930]],
            width: sizeFactor*580,
            height: sizeFactor*930
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Shower.ShowerDoor:
    case layouts[currentLayout].Shower.ShowerDoor2: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*350,0],[sizeFactor*950,0],[sizeFactor*950,sizeFactor*930],[sizeFactor*350,sizeFactor*930]],
            width: sizeFactor*600,
            height: sizeFactor*800
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*560,0],[sizeFactor*1240,0],[sizeFactor*1240,sizeFactor*930],[sizeFactor*560,sizeFactor*930]],
            width: sizeFactor*580,
            height: sizeFactor*930
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Accessories.LargeCornerCaddie:
    case layouts[currentLayout].Accessories.LargeCornerCaddie2: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*350,sizeFactor*30],[sizeFactor*950,sizeFactor*30],[sizeFactor*950,sizeFactor*930],[sizeFactor*350,sizeFactor*930]],
            width: sizeFactor*600,
            height: sizeFactor*900
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*560,0],[sizeFactor*1240,0],[sizeFactor*1240,sizeFactor*930],[sizeFactor*560,sizeFactor*930]],
            width: sizeFactor*580,
            height: sizeFactor*930
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Shower.Shower:
    case layouts[currentLayout].Shower.ShowerPanCombo: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*350,sizeFactor*730],[sizeFactor*950,sizeFactor*730],[sizeFactor*950,sizeFactor*930],[sizeFactor*350,sizeFactor*930]],
            width: sizeFactor*600,
            height: sizeFactor*200
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*560,sizeFactor*730],[sizeFactor*1260,sizeFactor*730],[sizeFactor*1260,sizeFactor*930],[sizeFactor*560,sizeFactor*930]],
            width: sizeFactor*700,
            height: sizeFactor*200
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Shower.TubCombo.WallConfiguration:
    case layouts[currentLayout].Shower.TubCombo.Liner:
    case layouts[currentLayout].Shower.TubCombo.JettedTub:
    case layouts[currentLayout].Shower.TubCombo.ReplacementTub:
    case layouts[currentLayout].Shower.TubCombo.WalkInTub:
      return {
        polygonArray: [[sizeFactor*300,sizeFactor*280],[sizeFactor*1000,sizeFactor*280],[sizeFactor*1000,sizeFactor*1080],[sizeFactor*300,sizeFactor*1080]],
        width: sizeFactor*700,
        height: sizeFactor*800
      };
    case layouts[currentLayout].Toilet:
    case layouts[currentLayout].PaperHolder: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*700,sizeFactor*500],[sizeFactor*1250,sizeFactor*500],[sizeFactor*1250,sizeFactor*1080],[sizeFactor*700,sizeFactor*1080]],
            width: sizeFactor*550,
            height: sizeFactor*580
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*100,sizeFactor*500],[sizeFactor*600,sizeFactor*500],[sizeFactor*600,sizeFactor*1080],[sizeFactor*100,sizeFactor*1080]],
            width: sizeFactor*500,
            height: sizeFactor*580
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Vanity.Cabinet:
      return {
        polygonArray: [[sizeFactor*920,sizeFactor*530],[sizeFactor*1920,sizeFactor*530],[sizeFactor*1920,sizeFactor*1080],[sizeFactor*920,sizeFactor*1080]],
        width: sizeFactor*1000,
        height: sizeFactor*550
      };
    case layouts[currentLayout].Vanity.CounterTop:
      return {
        polygonArray: [[sizeFactor*900,sizeFactor*500],[sizeFactor*1920,sizeFactor*500],[sizeFactor*1920,sizeFactor*1080],[sizeFactor*900,sizeFactor*1080]],
        width: sizeFactor*1020,
        height: sizeFactor*580
      };
    case layouts[currentLayout].Vanity.Faucet:
    case layouts[currentLayout].Vanity.Sink:
    case layouts[currentLayout].Vanity.VanityBacksplash: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*900,sizeFactor*400],[sizeFactor*1900,sizeFactor*400],[sizeFactor*1900,sizeFactor*830],[sizeFactor*800,sizeFactor*830]],
            width: sizeFactor*1000,
            height: sizeFactor*430
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*300,sizeFactor*400],[sizeFactor*730,sizeFactor*400],[sizeFactor*730,sizeFactor*930],[sizeFactor*300,sizeFactor*930]],
            width: sizeFactor*430,
            height: sizeFactor*530
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Vanity.Mirror:
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*1100,0],[sizeFactor*1900,0],[sizeFactor*1900,sizeFactor*640],[sizeFactor*1100,sizeFactor*640]],
            width: sizeFactor*800,
            height: sizeFactor*640
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*130,100],[sizeFactor*600,100],[sizeFactor*600,sizeFactor*540],[sizeFactor*130,sizeFactor*540]],
            width: sizeFactor*470,
            height: sizeFactor*440
          };
        }
      }
      return null;
    case layouts[currentLayout].Walls.CenterWall:
    case layouts[currentLayout].Background.CenterWall: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return null;
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*360,0],[sizeFactor*760,0],[sizeFactor*760,sizeFactor*880],[sizeFactor*360,sizeFactor*880]],
            width: sizeFactor*400,
            height: sizeFactor*880
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Walls.RightWall:
    case layouts[currentLayout].Background.RightWall: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*750,0],[sizeFactor*1920,0],[sizeFactor*1920,sizeFactor*1080],[sizeFactor*750,sizeFactor*1080]],
            width: sizeFactor*1170,
            height: sizeFactor*1080
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*120,0],[sizeFactor*1920,0],[sizeFactor*1920,sizeFactor*930],[sizeFactor*120,sizeFactor*930]],
            width: sizeFactor*1900,
            height: sizeFactor*930
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Walls.LeftWall:
    case layouts[currentLayout].Background.LeftWall: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[0,0],[sizeFactor*600,0],[sizeFactor*600,sizeFactor*1080],[0,sizeFactor*1080]],
            width: sizeFactor*600,
            height: sizeFactor*1080
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[0,0],[sizeFactor*600,0],[sizeFactor*600,sizeFactor*1080],[0,sizeFactor*1080]],
            width: sizeFactor*600,
            height: sizeFactor*1080
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Walls.CeilingPanels:
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*300,0],[sizeFactor*950,0],[sizeFactor*950,sizeFactor*100],[sizeFactor*300,sizeFactor*100]],
            width: sizeFactor*650,
            height: sizeFactor*100
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*560,0],[sizeFactor*1240,0],[sizeFactor*1240,sizeFactor*930],[sizeFactor*560,sizeFactor*930]],
            width: sizeFactor*580,
            height: sizeFactor*930
          };
        }
      }
      return null;
    case layouts[currentLayout].Background.Floor: {
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*100,sizeFactor*800],[sizeFactor*1300,sizeFactor*800],[sizeFactor*1300,sizeFactor*1080],[sizeFactor*100,sizeFactor*1080]],
            width: sizeFactor*1200,
            height: sizeFactor*280
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[0,sizeFactor*740],[sizeFactor*1920,740],[sizeFactor*1920,sizeFactor*1080],[0,sizeFactor*1080]],
            width: sizeFactor*1920,
            height: sizeFactor*340
          };
        }
      }
      return null;
    }
    case layouts[currentLayout].Background.ShowerWall:
      switch (currentLayout) {
        case LayoutAbbreviation.Layout1: {
          return {
            polygonArray: [[sizeFactor*350,0],[sizeFactor*1650,0],[sizeFactor*1650,sizeFactor*930],[sizeFactor*350,sizeFactor*930]],
            width: sizeFactor*1300,
            height: sizeFactor*930
          };
        }
        case LayoutAbbreviation.Layout4: {
          return {
            polygonArray: [[sizeFactor*250,0],[sizeFactor*1250,0],[sizeFactor*1250,sizeFactor*930],[sizeFactor*250,sizeFactor*930]],
            width: sizeFactor*1000,
            height: sizeFactor*930
          };
        }
      }
      return null;
    case layouts[currentLayout].Bathtub.BathTubBody:
      return {
        polygonArray: [[sizeFactor*800,sizeFactor*580],[sizeFactor*1920,sizeFactor*580],[sizeFactor*1920,sizeFactor*1080],[sizeFactor*800,sizeFactor*1080]],
        width: sizeFactor*1120,
        height: sizeFactor*500
      };
    case layouts[currentLayout].Bathtub.BathTubFixture:
      return {
        polygonArray: [[sizeFactor*1380,sizeFactor*370],[sizeFactor*1660,sizeFactor*370],[sizeFactor*1660,sizeFactor*1000],[sizeFactor*1380,sizeFactor*1000]],
        width: sizeFactor*280,
        height: sizeFactor*730
      };
    default:
      return null
  }
};

export default {
  layouts,
  getMenuByHoveredLayer: (currentLayout, layer) => {
    // console.log('currentLayout', currentLayout);
    // console.log('layer', layer);
    switch (layer.zIndex) {
      // General
      case layouts[currentLayout].Ceiling:
        return "Ceiling";
      case layouts[currentLayout].Toilet:
        return {
          parent: "Toilet",
          child: "Toilet"
        };
      case layouts[currentLayout].PaperHolder:
        return {
          parent: "Toilet",
          child: "Paper Holder"
        };
      // case layouts[currentLayout].Shower.ExtrusionWallLeft:
      // case layouts[currentLayout].Shower.Body["1"]:
      // case layouts[currentLayout].Shower.Body["2"]:
      // case layouts[currentLayout].Shower.Fixture:
      //     return {
      //         parent: "Shower",
      //         child: "Shower Body"
      //     };
      case layouts[currentLayout].Wall_A:
        return {
          parent: "Walls",
          child: "Wall A"
        };
      case layouts[currentLayout].Wall_C:
        return {
          parent: "Walls",
          child: "Wall C"
        };
      case layouts[currentLayout].Vanity.Mirror:
        return {
          parent: "Vanity",
          child: "Mirror"
        };
      // case layouts[currentLayout].Shower.ExtrusionWallLeft:
      // case layouts[currentLayout].Shower.ExtrusionWallLeftHalfWall:
      // case layouts[currentLayout].Shower.PonyWall:
      //   return "left_wall_custom";
      case layouts[currentLayout].Vanity.VanityBacksplash:
      case layouts[currentLayout].Wall_B:
        return "wall_b_custom";
      case layouts[currentLayout].Vanity.Handle:
      case layouts[currentLayout].Vanity.CounterTop:
      case layouts[currentLayout].Vanity.Faucet:
      case layouts[currentLayout].Vanity.Sink:
      case layouts[currentLayout].Vanity.Cabinet:
        return "vanity_custom";

      case layouts[currentLayout].Shower.Threshold:
        return {
          parent: "Shower",
          child: "Threshold"
        };
      case layouts[currentLayout].Accessories.CornerCaddie:
      case layouts[currentLayout].Accessories.CornerCaddie2:
        return {
          parent: "Shower Accessories",
          child: "Corner Caddie"
        };
      case layouts[currentLayout].Accessories.LargeCornerCaddie:
      case layouts[currentLayout].Accessories.LargeCornerCaddie2:
        return {
          parent: "Shower Accessories",
          child: "Large Corner Caddie"
        };
      case layouts[currentLayout].Accessories.LargeCornerSeat:
      case layouts[currentLayout].Accessories.LargeCornerSeat2:
        return {
          parent: "Shower Accessories",
          child: "Large Corner Seat"
        };
      case layouts[currentLayout].Accessories.SoapDish:
      case layouts[currentLayout].Accessories.SoapDish2:
      case layouts[currentLayout].Accessories.SoapDish3:
        return {
          parent: "Shower Accessories",
          child: "Soap Dish"
        };
      case layouts[currentLayout].Accessories.SmallCornerShelf:
        return {
          parent: "Shower Accessories",
          child: "Small Corner Shelf"
        };
      case layouts[currentLayout].Accessories.GrabBar:
      case layouts[currentLayout].Accessories.GrabBar2:
      case layouts[currentLayout].Accessories.GrabBar3:
        return {
          parent: "Shower Accessories",
          child: "Grab Bar"
        };
      case layouts[currentLayout].Accessories.CornerShelf1:
      case layouts[currentLayout].Accessories.CornerShelf2:
      case layouts[currentLayout].Accessories.CornerShelf3:
      case layouts[currentLayout].Accessories.CornerShelf4:
      case layouts[currentLayout].Accessories.CornerShelf5:
      case layouts[currentLayout].Accessories.CornerShelf6:
        return {
          parent: "Shower Accessories",
          child: "Corner Shelf"
        };
      case layouts[currentLayout].Accessories.ShowerPod:
        return {
          parent: "Shower Accessories",
          child: "Shower Pod"
        };
      case layouts[currentLayout].Accessories.LargeShelf:
        return {
          parent: "Shower Accessories",
          child: "Large Shelf"
        };
      case layouts[currentLayout].Accessories.ShampooShelf:
        return {
          parent: "Shower Accessories",
          child: "Shampoo Shelf"
        };
      case layouts[currentLayout].Accessories.Seats:
      case layouts[currentLayout].Accessories.Seats2:
        return {
          parent: "Shower Accessories",
          child: "Seats"
        };
      case layouts[currentLayout].Accessories.ShowerRod:
        return {
          parent: "Shower Accessories",
          child: "Shower Rod"
        };
      case layouts[currentLayout].Accessories.TowelBar:
        return {
          parent: "Shower Accessories",
          child: "Towel Bar"
        };
      case layouts[currentLayout].Accessories.WindowBody:
        return {
          parent: "Shower Accessories",
          child: "Window"
        };
      case layouts[currentLayout].Accessories.WindowKits:
        return {
          parent: "Shower Accessories",
          child: "Window Kits"
        };
      case layouts[currentLayout].Accessories.SeatPad:
      case layouts[currentLayout].Accessories.SeatPad2:
        return {
          parent: "Shower Accessories",
          child: "Seat Pad"
        };
      case layouts[currentLayout].Accessories.LShapedGrabBar:
        return {
          parent: "Shower Accessories",
          child: "L Shaped Grab Bar"
        };
      case layouts[currentLayout].Accessories.HandShowerKit:
        return {
          parent: "Shower Accessories",
          child: "Hand Shower Kit"
        };
      case layouts[currentLayout].Accessories.HandleShowerValve:
        return {
          parent: "Shower Accessories",
          child: "Handle Shower Valve"
        };
      case layouts[currentLayout].Walls.RightWall:
      case layouts[currentLayout].Background.RightWall:
        return {
          parent: "Walls",
          child: "Right Wall"
        };
      case layouts[currentLayout].Background.LeftWall:
      case layouts[currentLayout].Walls.LeftWall:
        return {
          parent: "Walls",
          child: "Left Wall"
        };
      case layouts[currentLayout].Background.CenterWall:
      case layouts[currentLayout].Walls.CenterWall:
        return {
          parent: "Walls",
          child: "Center Wall"
        };
      case layouts[currentLayout].Walls.CeilingPanels:
        return {
          parent: "Walls",
          child: "Ceiling Panels"
        };
      case layouts[currentLayout].Shower.ShowerArm:
      case layouts[currentLayout].Shower.ShowerArm2:
        return {
          parent: "Shower",
          child: "Shower Arm"
        };
      case layouts[currentLayout].Shower.ShowerHead:
      case layouts[currentLayout].Shower.ShowerHead2:
        return {
          parent: "Shower",
          child: "Shower Head"
        };
      case layouts[currentLayout].Background.Floor:
        return {
          parent: "Floor",
          child: "Floor"
        };
      case layouts[currentLayout].Shower.Glass:
      case layouts[currentLayout].Shower.Floor:
      case layouts[currentLayout].Shower.ShowerPanCombo:
      case layouts[currentLayout].Background.ShowerWall:
      case layouts[currentLayout].Shower.Body:
      case layouts[currentLayout].Shower.Overlay:
      case layouts[currentLayout].Shower.ShowerDoor:
      case layouts[currentLayout].Shower.ShowerDoor2:
      case layouts[currentLayout].Shower.ShowerDoorHandle:
      case layouts[currentLayout].Shower.ExtrusionWallLeft:
      case layouts[currentLayout].Shower.Fixture:
      case layouts[currentLayout].Shower.ShowerFixture:
      case layouts[currentLayout].Shower.ShowerFixture2:
      case layouts[currentLayout].Shower.ShowerFixture3:
      case layouts[currentLayout].ShowerWallAccent:
        return "shower_custom";
      case layouts[currentLayout].Shower.TubCombo.Liner:
      case layouts[currentLayout].Shower.TubCombo.ReplacementTub:
      case layouts[currentLayout].Shower.TubCombo.WalkInTub:
      case layouts[currentLayout].Shower.TubCombo.JettedTub:
      case layouts[currentLayout].Shower.TubCombo.WallConfiguration:
        return "shower_combo";
      // BathTub
      case layouts[currentLayout].Shower.PonyWallCap:
      case layouts[currentLayout].Shower.PonyWallGlass:
        return "shower_pony_wall";
      case layouts[currentLayout].Bathtub.BathTubBody:
      case layouts[currentLayout].Bathtub.BathTubFixture:
        return "bathtub_custom";
      default:
        return ""
    }
  },
  getLayerDimensions
}


